import { pushToDataLayer } from '../../pushToDataLayer';
import { GTMEvent, GTMEventAttributes, GTMEventName } from '../../types';
import { GTMRecentlyDeletedInteractionAction } from './types';

export function recentlyDeletedInteractionEvent({
  action,
  videoIds,
}: {
  action: GTMRecentlyDeletedInteractionAction;
  videoIds: number[];
}) {
  const eventAttributes: GTMEventAttributes = {
    event: GTMEvent.COVIDEO_EVENT,
    event_name: GTMEventName.RECENTLY_DELETED_INTERACTION,
  };

  pushToDataLayer({
    ...eventAttributes,
    action,
    video_ids: videoIds,
  });
}
